module.exports = __webpack_public_path__ + "img/fb.bd17e8d8.png";